import { createContext } from 'react';


        // =======================================================================
        // Toast / notifications
        // =======================================================================
        const ToastCtx = createContext(null);

export { ToastCtx };
